import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Box, Spinner, Alert, AlertIcon, Text } from '@chakra-ui/react';
import { supabase } from '../supabaseClient';

export default function ShortUrlRedirect() {
  const { shortCode } = useParams();
  const [loading, setLoading] = useState(true);
  const [doctorId, setDoctorId] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const resolveShortUrl = async () => {
      try {
        // Look up the short code
        const { data, error } = await supabase
          .from('short_urls')
          .select(`
            doctor_id,
            expires_at,
            is_active,
            doctors (
              id,
              agreement_signed
            )
          `)
          .eq('short_code', shortCode)
          .eq('is_active', true)
          .single();

        if (error) {
          if (error.code === 'PGRST116') {
            setError('Invalid or expired link');
          } else {
            setError('Error loading link');
          }
          setLoading(false);
          return;
        }

        // Check if expired
        if (data.expires_at && new Date(data.expires_at) < new Date()) {
          setError('This link has expired');
          setLoading(false);
          return;
        }

        // Check if doctor already signed
        if (data.doctors.agreement_signed) {
          // Redirect to thank you page
          window.location.href = 'https://athomeblooddraw.com/thank-you';
          return;
        }

        // Mark as used (optional tracking)
        await supabase
          .from('short_urls')
          .update({ used_at: new Date().toISOString() })
          .eq('short_code', shortCode);

        setDoctorId(data.doctor_id);
      } catch (error) {
        setError('Error resolving link');
      } finally {
        setLoading(false);
      }
    };

    if (shortCode) {
      resolveShortUrl();
    } else {
      setError('Invalid link');
      setLoading(false);
    }
  }, [shortCode]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <Spinner size="xl" />
        <Text ml={4}>Loading...</Text>
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={8} textAlign="center">
        <Alert status="error" maxW="400px" mx="auto">
          <AlertIcon />
          {error}
        </Alert>
      </Box>
    );
  }

  if (doctorId) {
    return <Navigate to={`/doctor-agreement/${doctorId}`} replace />;
  }

  return (
    <Box p={8} textAlign="center">
      <Alert status="error" maxW="400px" mx="auto">
        <AlertIcon />
        Invalid link
      </Alert>
    </Box>
  );
} 